<template>
  <div class="flex flex-col lg:flex-row lg:space-x-6 mr-6 w-full">
    <div
      class="bg-white rounded-xl rounded-tl-none shadow w-full py-16 px-12 lg:p-16 mb-12 lg:mb-0"
    >
      <TabHeader :title="tab.title">
        <template #header-action>
          <slot name="header-action" />
        </template>
      </TabHeader>

      <hr class="w-full my-8" />

      <TabContent :tab="tab" :wrapper-class="wrapperClassContent">
        <template #default>
          <slot />
        </template>
      </TabContent>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import TabHeader from './TabHeader.vue'
import TabContent from './TabContent.vue'

export default defineComponent({
  name: 'Tab',

  components: {
    TabHeader,
    TabContent,
  },

  props: {
    tab: {
      type: Object,
      required: true,
    },

    wrapperClassContent: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {}
  },
})
</script>
